import React,{ useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { makeStyles } from '@material-ui/core/styles';

// Component
const Placeholder = (props) => {
  const classes = useStyles();

  // Load Dynamic Image
  const loadImage = () => {
    switch (props.image) {
      case "assign":
        //return require('../../assets/Assign_place.png');
      case "error":
        //return require('../../assets/error.jpeg');
    }
  };

  // JSX template
  return (
    <Grid sx={{textAlign:'center'}}>
      <Box>
        <img
          className={classes.placeholderImage}
          src={loadImage()}
        />
      </Box>
      <Box>
        <Typography className={classes.primarytext}>{props.primaryText}</Typography>
        <Typography className={classes.secondarytext}>{props.secondaryText}</Typography>
      </Box>
    </Grid>
  );
};

// Styles
const useStyles = makeStyles({
  placeholderImage: {
    width: '10rem',
    height: '10rem',
    textAlign: 'center',
    marginTop: 50,
  },
  primarytext: {
    fontSize: "1rem",
    color: "#A9A9A9",
    textAlign: "center",
  },
  secondarytext: {
    fontSize: "0.8rem",
    color: "#A9A9A9",
    paddingHorizontal: 15,
    textAlign: "center",
    marginTop: 10,
  },
});

export default Placeholder;
